// extracted by mini-css-extract-plugin
export default {"foodCardPage":"FoodCard_foodCardPage__BWTy6"};